/**
 * @module bankAccountType
 * @description A list of bankAccountType
 */
export const bankAccountType = [
	'Cheque account',
	'Transactional account',
	'Savings account',
	'Fixed / Deposit account',
	'Business account',
	'Resident and Non-Resident account',
	'Other',
] as const;
export type BankAccountType = (typeof bankAccountType)[number];
